import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Modal,
  Form,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Space,
  Divider,
} from "antd";
import SectionHeading from "./section-headings";
import {
  EditOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import {
  orgmode,
  showloader,
  productSelection,
  checkFilledDirector,
  directorsData,
  inwardPartner,
  newPartnerList,
  hasInwardBank,
} from "../../store/gloabalState";
import config from "../../config/form.json";
import DirectorFileComponent from "../onboarding/directorFileComponent";
import { CountryCode, emailRegex, phoneRegex } from "../../config/globalVar";
import dayjs from "dayjs";
import useNotify from "../../utils/useNotify";
import Cookies from "js-cookie";
import { getDirectorsProbe } from "../../utils/onboarding/director-details/get-directors-probe";
import DocsUploadAuthSig from "../onboarding/authFileComponent";
import {
  putAuthSignatory,
  getAllAuths,
  postAuthSignatory,
} from "../../services/httpCalls";
import SignatoryCard from "./signatory-card";
import {
  showField,
  NEW_REFACTOR,
} from "../../utils/onboarding/onboardingUtils";
import { detailsFill } from "../../utils/onboarding/director-details/details-fill";
import { getProductionSelectionType } from "../../utils/onboarding/onboardingUtils";

const Signatories = () => {
  // initializing form
  const [form] = Form.useForm();

  // getting directors config data;
  const configData = config.directorDetails[1].signatories[0];

  // local states
  const [auths, setAuths] = useState([]);
  const [refreshIn, setRefreshIn] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [payloadAuths, setPayloadAuths] = useState([]);
  const [flagAuths, setFlagAuths] = useState(true);
  const [editData, setEditData] = useState();
  const [openauthModal, setOpenauthModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [panDoc, setPanDoc] = useState();
  const [warningDirector, setWarningDirector] = useState([]);
  const [aadDoc, setAadDoc] = useState();
  const [newName, setNewName] = useState();
  const [refresh, setRefresh] = useState(false);
  const [authFiles, setAuthFiles] = useState();
  const [namesList, setNamesList] = useState([]);
  const [filesAdded, setFilesAdded] = useState();
  const [checknationalityIndian, setCheckIndianNationality] = useState(true);

  // global states
  const partnerState = useRecoilValue(inwardPartner);
  const partnerListState = useRecoilValue(newPartnerList);

  // values
  const directors = useRecoilValue(directorsData);
  const mode = useRecoilValue(orgmode);
  const hasInwardBankValue = useRecoilValue(hasInwardBank);

  // updater/setter
  const setShowLoader = useSetRecoilState(showloader);

  // states
  const [validateDir, setValidateDir] = useRecoilState(checkFilledDirector);
  let [selectionValue, setSelectionValue] = useRecoilState(productSelection);

  // constants/binders
  let directors_ = [];
  let postDataArray = [];
  let notify = useNotify();
  const emailRegexRef = emailRegex;
  const phoneRegexRef = phoneRegex;
  const { confirm } = Modal;
  const dateFormat = "DD/MM/YYYY";
  const CountryCodeInstance = CountryCode;
  const dayjsInstance = dayjs;
  const { hasOnlyPayglocal } = getProductionSelectionType(
    selectionValue,
    partnerState,
    hasInwardBankValue
  );

  const handleClose = () => {
    setOpen(!open);
    form.resetFields();
  };

  const handleOpen = () => {
    form.resetFields();
    setEditFlag(false);
    setOpen(!open);
    setAuthFiles([]);
    setPanDoc([]);
    setAadDoc([]);
    setFilesAdded([]);
    setCheckIndianNationality(true);
  };

  const handleDetailFill = () => {
    detailsFill({
      form,
      directors,
      setCheckIndianNationality,
      setPanDoc,
      setAadDoc,
      setFilesAdded,
    });
  };

  const addNewNames = (names_) => {
    if (names_ && !refreshIn) {
      setNamesList(names_);
      setRefreshIn(true);
    }
  };

  useEffect(() => {
    if (editFlag) {
      setCheckIndianNationality(
        editData.nationality === "Indian" || editData.nationality === "IN"
          ? true
          : false
      );
      form.setFieldsValue({
        ["name"]: editData?.name,
        ["firstName"]: editData?.firstName,
        ["lastName"]: editData?.lastName,
        ["pan"]: editData?.panNumber,
        ["motherName"]: editData?.motherName,
        ["Fathername"]: editData?.fatherName,
        ["emailId"]: editData?.emailId,
        ["mobile"]: editData?.phoneNumber,
        ["gender"]: editData?.gender,
        ["dob"]: dayjs(editData?.dob, "DD/MM/YYYY"),
        ["Nationality"]: editData?.nationality,
        ["addressLineOne"]: editData?.address?.addressLineOne,
        ["addressLineTwo"]: editData?.address?.addressLineTwo,
        ["city"]: editData?.address?.city,
        ["country"]: editData?.address?.country,
        ["state"]: editData?.address?.state,
        ["pinCode"]: editData?.address?.pinCode,
        ["designation"]: editData?.designation,
      });

      if (editData?.docs?.length) {
        editData?.docs?.forEach((elem) => {
          if (elem.type === "AUTHORIZED_SIGNATORY_PAN") {
            setPanDoc(elem);
          } else if (elem.type === "AUTHORIZED_SIGNATORY_ADHAAR") {
            setAadDoc(elem);
          }
        });
        setFilesAdded(editData?.docs);
      }

      // setAuthFiles(editData?.docs)
    }
  }, [editFlag, open]);

  useEffect(() => {
    if (directors?.length) {
      let names_ = [];
      directors.forEach((elem) => {
        names_.push(elem.name);
      });
      addNewNames(names_);
    }
  }, [directors, editFlag]);

  const addNewItem = () => {
    if (newName) {
      let names_ = namesList;
      if (!names_.includes(newName)) {
        names_.push(newName);
        setNamesList(names_);
        setNewName("");
      } else {
        notify.error("Name already exist!");
      }
    }
  };

  const handleDropdownRender = (menu) => {
    return (
      <>
        {menu}
        <Divider style={{ margin: "8px 0" }} />
        <Typography style={{ fontWeight: "bold", margin: "0.5rem" }}>
          Add new Name
        </Typography>
        <Space style={{ padding: "0 8px 4px" }}>
          <Input
            onChange={(e) => setNewName(e.target.value)}
            value={newName}
            placeholder="Enter Here"
          />
          <Button
            className="add-button"
            type="primary"
            icon={<PlusOutlined />}
            onClick={addNewItem}
          >
            Add
          </Button>
        </Space>
      </>
    );
  };

  useEffect(() => {
    if (flagAuths && auths.length) {
      setFlagAuths(false);
      setPayloadAuths(auths);
    }
  }, [auths]);

  const editOpenAuth = (elem) => {
    setEditFlag(true);
    setEditData(elem);
    setOpen(true);
  };

  const deleteAuth = (elem) => {
    setShowLoader(true);
    let data = {
      status: "DELETED",
    };
    let orgId = localStorage.getItem("orgId");
    putAuthSignatory(orgId, elem.id, data)
      .then(() => {
        notify.success("Authorized Signatory Deleted!");
      })
      .catch(() => {
        notify.error("Error deleting Authorized Signatory!");
      })
      .finally(() => {
        setShowLoader(false);
        setRefresh(true);
      });
  };

  const showAuthDeleteConfirm = (elem, val) => {
    confirm({
      title: (
        <p>
          Are you sure you want to delete this Authorized Signatory? <br />{" "}
          <b>{elem?.name}</b>
        </p>
      ),
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteAuth(elem),
    });
  };

  useEffect(() => {
    setRefresh(false);
    setShowLoader(true);
    async function getAuthFunc() {
      let orgId = localStorage.getItem("orgId");
      await getAllAuths(orgId)
        .then((res) => {
          if (res) {
            let finalres = [];
            if (res?.length) {
              finalres = res?.filter((val) => val?.status !== "DELETED");
            }
            setAuths(finalres);
          }
        })
        .catch(() => {
          notify.error("Not able to get data!");
        })
        .finally(() => {
          setShowLoader(false);
          setRefresh(false);
        });
    }
    getAuthFunc();
  }, [refresh]);

  const handleFormFinish = async (values) => {
    let orgId = localStorage.getItem("orgId");
    let data = {};
    if (!hasOnlyPayglocal) {
      if (!form.getFieldValue("dob")) {
        form.setFields([
          {
            name: "dob",
            errors: ["Required!"],
          },
        ]);
        return;
      }
    }
    if (partnerState?.includes("payglocal")) {
      data = {
        name: values?.lastName
          ? values.firstName + " " + values.lastName
          : values.firstName,
        firstName: values?.firstName,
        lastName: values?.lastName,
        emailId: values.emailId,
        panNumber: values.pan,
        designation: values.designation,
        status: "ACTIVE",
        phoneNumber: values.mobile,
        docs: filesAdded,
        dob: values?.dob?.format("DD/MM/YYYY"),
      };
    } else {
      data = {
        name: values?.lastName
          ? values.firstName + " " + values.lastName
          : values.firstName,
        firstName: values.firstName,
        lastName: values.lastName,
        emailId: values.emailId,
        motherName: values.motherName,
        fatherName: values.Fathername,
        phoneNumber: values.mobile,
        panNumber: values.pan,
        gender: values.gender,
        dob: values?.dob?.format("DD/MM/YYYY"),
        nationality: values.Nationality,
        address: {
          addressLineOne: values.addressLineOne,
          addressLineTwo: values.addressLineTwo,
          city: values.city,
          state: values.state,
          country: values.country,
          pinCode: values.pinCode,
        },
        status: "ACTIVE",
        docs: filesAdded,
      };
    }
    let directors_ = JSON.parse(localStorage.getItem("directors_"));
    directors_?.forEach((elem, i) => {
      if (elem.panNumber === values.pan) {
        data.id = elem.id;
        directors_[i] = data;
      }
    });
    localStorage.setItem("directors_", JSON.stringify(directors_));
    if (editFlag) {
      try {
        await putAuthSignatory(orgId, editData.id, data);
        notify.success("Successfully added authorised signatory!");
        form.resetFields();
        setRefresh(true);
        handleClose();
        setShowLoader(false);
        setRefresh(true);
      } catch {
        notify.error("Not able to Add!");
        setShowLoader(false);
      }
    } else {
      try {
        await postAuthSignatory(data, orgId);
        notify.success("Successfully added authorised signatory!");
        form.resetFields();
        setRefresh(true);
        handleClose();
        setShowLoader(false);
        setRefresh(true);
        setShowLoader(false);
      } catch {
        notify.error("Not able to Add!");
        setShowLoader(false);
      }
    }
  };

  const handleValuesChange = (value) => {
    if (value?.nationality === "Indian") {
      setCheckIndianNationality(true);
    } else if (value?.nationality === "Foreigner") {
      setCheckIndianNationality(false);
    }
  };

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // * formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "Form.Item":
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields
              ? field?.subFields.map((child, childIndex) =>
                  renderField(child, childIndex)
                )
              : null}
          </React.Fragment>
        );
      case "Input":
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            maxLength={field?.maxLength}
            type={field?.subType}
          />
        );
      case "Button":
        return (
          <Button
            type={type}
            style={style}
            onClick={eval(props.onClick)}
            disabled={eval(props.disabled)}
          >
            {eval(label)}
          </Button>
        );
      case "Select":
        return (
          <Select
            options={eval(field?.options)}
            readOnly={eval(props?.readOnly)}
            disabled={eval(props?.disabled)}
            showSearch={props?.showSearch}
            allowClear={props?.allowClear}
            default={field?.default}
            filterOption={eval(props?.filterOption)}
            onKeyUp={eval(props?.onKeyUp)}
            optionFilterProp={props?.optionFilterProp}
            placeholder={field?.placeholder}
            dropdownRender={eval(props?.dropdownRender)}
            onChange={eval(props?.onChange)}
          />
        );
      case "DatePicker":
        return (
          <DatePicker
            format={eval(props?.dateFormat)}
            disabledDate={eval(props?.disabledDate)}
            style={field?.style}
          />
        );
      case "InputNumber":
        return (
          <InputNumber
            style={style}
            type={props.type}
            controls={field?.controls}
            onKeyUp={eval(props?.onKeyUp)}
            readOnly={eval(props?.readOnly)}
          />
        );
      case "SectionHeading":
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        );
      case "DocsUploadAuthSig":
        return (
          <DocsUploadAuthSig
            name={field?.name}
            type={field?.subType}
            doc={eval(props?.doc)}
            files={eval(props?.files)}
            filesAdded={eval(props?.filesAdded)}
            setFilesAdded={eval(props?.setFilesAdded)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div>
        <Typography.Title level={4}>Authorized Signatories</Typography.Title>
      </div>
      <div
        style={{
          padding: "0px",
          margin: ".5rem 0",
        }}
      >
        <Button
          type="primary"
          onClick={handleOpen}
          disabled={
            mode === "view" ||
            (Boolean(partnerState.length) &&
              partnerState.every((ele) => ele === "payglocal") &&
              auths.length >= 1)
              ? true
              : false
          }
        >
          Add authorized signatories
        </Button>
      </div>
      <SignatoryCard
        mode={mode}
        auths={auths}
        editOpenAuth={editOpenAuth}
        selectionValue={selectionValue}
        warningDirector={warningDirector}
        showAuthDeleteConfirm={showAuthDeleteConfirm}
      />
      <Modal
        open={open}
        onCancel={handleClose}
        width={800}
        style={{ top: 20 }}
        footer={null}
        title={
          <Typography.Title level={4} style={{ margin: 0 }}>
            {editFlag
              ? "Edit Authorized Signatory"
              : "Add Authorized Signatory"}
          </Typography.Title>
        }
      >
        <div>
          <Form
            {...configData.formConfig}
            form={form}
            onFinish={handleFormFinish}
            onValuesChange={handleValuesChange}
            disabled={mode === "view"}
          >
            <Row gutter={[16, 16]}>
              {configData.fields.map((field, index) => {
                const checkNaitonalityBoolean = partnerState.includes(
                  "payglocal"
                )
                  ? true
                  : field?.checkNationality
                  ? checknationalityIndian
                    ? field?.checkNationality === "Indian"
                    : field?.checkNationality === "Foreigner"
                  : true;

                // conditional render
                const isVisible =
                  showField(field.productList, partnerListState) &&
                  checkNaitonalityBoolean;

                const isRefactoredRender = isVisible;

                return (
                  isRefactoredRender && (
                    <Col key={index} span={field?.Col ? field.Col : 12}>
                      {renderField(field, index)}
                    </Col>
                  )
                );
              })}
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
              }}
            >
              <Button
                onClick={() => {
                  setOpen(false);
                  form.resetFields();
                }}
                style={{ marginRight: "1rem" }}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default Signatories;
